import Decimal from "decimal.js";
import { ISubscriptionAppliedDiscount } from "@api-clients/subscriptions";

import { DiscountCodeType } from "@/primary-models";

export const getDiscountFromDiscountData = (
  discountData: ISubscriptionAppliedDiscount[] | null | undefined,
): string | undefined => {
  if (!discountData) {
    return undefined;
  }
  // Get the last discount
  const discount = discountData.at(-1);
  if (!discount) {
    return undefined;
  }
  return getDiscount(discount.amount, discount.type, discount.totalPriceReducedBy);
};

export const getWholeOrDecimal = (value: string) => {
  const price = new Decimal(value);
  return price.mod(1).isZero() ? price.toFixed(0) : price.toFixed(2);
};

export const getDiscount = (
  amount: string,
  type: DiscountCodeType,
  totalPriceReducedBy: string,
): string => {

  if (type === DiscountCodeType.PERCENTAGE) {
    return `${new Decimal(amount).toFixed(2).replace(/\.?0+$/, "")}%`;
  }

  if (type === DiscountCodeType.ABSOLUTE_TOTAL) {
    return `£${getWholeOrDecimal(totalPriceReducedBy)}`;
  }

  return `£${getWholeOrDecimal(amount)}`;
};
